import {state} from './state'

export default {
  namespaced: true,
  state
}
